import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import "./assets/css/main.css";
import { registerUiComponents } from "./components/ui";

const app = createApp(App);

// Componentes UI globales (UiButton, UiInput, UiSelect, UiTable, UiTextarea, UiModal, UiFileUpload):
// disponibles en cualquier SFC sin necesidad de importarlos.
registerUiComponents(app);

app.use(router).mount("#app");

// main.js

// Escuchamos el evento 'input' a nivel de documento
document.addEventListener('input', (event) => {
  const target = event.target;

  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {

    if (target.classList.contains('no-uppercase')) return;

    const type = target.type;
    if (['password', 'email', 'date', 'number', 'range', 'checkbox','file'].includes(type)) return;

    const start = target.selectionStart;
    const end = target.selectionEnd;

    const value = target.value;
    if (value !== value.toUpperCase()) {
      target.value = value.toUpperCase();
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.setSelectionRange(start, end);
    }
  }
}, true);

document.addEventListener('change', (event) => {
  const target = event.target;

  // Solo actuamos en inputs de tipo 'number'
  if (target.tagName === 'INPUT' && target.type === 'number') {

    // Obtenemos el valor actual
    let value = parseFloat(target.value);

    // Si es un número válido, lo formateamos a 2 decimales
    if (!isNaN(value)) {
      // Redondeamos y fijamos 2 decimales
      const formattedValue = value.toFixed(2);

      // Actualizamos el valor del DOM
      target.value = formattedValue;

      // Disparamos el evento input para que Vue actualice el v-model internamente
      target.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}, true);